import React from 'react';
import { Departamento, Usuario } from '../../types';

interface DetalheDepartamentoProps {
  departamento: Departamento;
  lideres: Usuario[];
  membros: Usuario[];
}

const DetalheDepartamento: React.FC<DetalheDepartamentoProps> = ({ 
  departamento, 
  lideres, 
  membros 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-gray-800">{departamento.nome}</h2>
        <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
          {membros.length} membros
        </span>
      </div>

      {/* Seção de líderes */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold mb-3 text-gray-700 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
          </svg>
          Líderes
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {lideres.length > 0 ? (
            lideres.map(lider => (
              <div key={lider.id} className="flex items-center p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                <img 
                  src="/profilepicture.png" 
                  alt={lider.nome} 
                  className="w-10 h-10 rounded-full mr-3"
                />
                <div>
                  <p className="font-medium text-gray-800">{lider.nome}</p>
                  <p className="text-xs text-gray-500">{lider.cargo}</p>
                  <p className="text-xs text-gray-500">{lider.email}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 italic col-span-2">Nenhum líder designado para este departamento</p>
          )}
        </div>
      </div>

      {/* Seção de membros */}
      <div>
        <h3 className="text-lg font-semibold mb-3 text-gray-700 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          Membros
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {membros.map(membro => (
            <div key={membro.id} className="flex items-center p-3 bg-gray-50 border border-gray-200 rounded-lg">
              <img 
                src="/profilepicture.png" 
                alt={membro.nome} 
                className="w-10 h-10 rounded-full mr-3"
              />
              <div>
                <p className="font-medium text-gray-800">{membro.nome}</p>
                <p className="text-xs text-gray-500">{membro.cargo}</p>
                {membro.ehLider === true && (
                  <span className="inline-block mt-1 bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-0.5 rounded">
                    Líder
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetalheDepartamento;
